import api, { BodyData } from '../../../utils/api';

export interface ApproveHomeseekerApplicationPayload extends BodyData {
    readonly homeseekerApplicationIds: string[];
}

const ApproveHomeseekerApplication = async (payload: ApproveHomeseekerApplicationPayload): Promise<unknown> => {
    return await api.post('api/homeseeker/applications/approve', payload);
}

export default ApproveHomeseekerApplication;
